import {
    FORGOT_PASSWORD_ERROR,
    FORGOT_PASSWORD_ERROR_CLEAR,
    FORGOT_PASSWORD_PENDING,
    FORGOT_PASSWORD_SUCCESS,
} from "./constants"

const initialState = {
    isforgotPasswordPending: false,
    forgotPasswordErrorMessage: null,
    successMessage: null,
}

const forgotPassword = (state = initialState, action) => {

    switch (action.type) {
        case FORGOT_PASSWORD_PENDING: {
            return {
                ...state,
                isforgotPasswordPending: true
            }
        }

        case FORGOT_PASSWORD_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...state,
                forgotPasswordErrorMessage: errorMessage,
                isforgotPasswordPending: false,
                successMessage: null,
            }
        }

        case FORGOT_PASSWORD_ERROR_CLEAR: {
            return {
                ...state,
                forgotPasswordErrorMessage: null,
                isforgotPasswordPending: false,
                successMessage: null,
            }
        }

        case FORGOT_PASSWORD_SUCCESS: {
            const { successMessage } = action.payload;
            return {
                ...state,
                successMessage: successMessage,
                forgotPasswordErrorMessage: null,
                isforgotPasswordPending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default forgotPassword;